import React from "react";

export default function TrialEndBandSection(props) {
  return (
    <div className="billingbandinfo-wrapper">
      <span>{props.mainMessage}</span>
      <span
        onKeyPress={() => null}
        role="button"
        tabIndex="0"
        onClick={() => props.actionOnTextClick()}
        className="billingbandinfo-updgrade-link">
        {props.secondaryMessage}
      </span>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/BillingBandInfo/TrialEndBandSection.js